import { render } from "./AuthOfficialBusinessStatusTracker.vue?vue&type=template&id=7b2ea847&scoped=true"
import script from "./AuthOfficialBusinessStatusTracker.vue?vue&type=script&lang=js"
export * from "./AuthOfficialBusinessStatusTracker.vue?vue&type=script&lang=js"

import "./AuthOfficialBusinessStatusTracker.vue?vue&type=style&index=0&id=7b2ea847&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ea847"]])

export default __exports__